import { NavLink, Outlet, Link } from "react-router-dom";
import { Package, ShoppingCart, Mail, LogOut, ExternalLink, Images, LayoutTemplate, MapPin, GalleryHorizontal, Target, KeyRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import logoWhite from "@/assets/ping-logo-white.png";

const NAV = [
  { to: "/admin/products", label: "Products", icon: Package, testid: "admin-nav-products" },
  { to: "/admin/banners", label: "Home Banners", icon: Images, testid: "admin-nav-banners" },
  { to: "/admin/category-banners", label: "Category Banners", icon: GalleryHorizontal, testid: "admin-nav-category-banners" },
  { to: "/admin/putter-subcategories", label: "Putter Families", icon: Target, testid: "admin-nav-putter-subs" },
  { to: "/admin/content", label: "Content", icon: LayoutTemplate, testid: "admin-nav-content" },
  { to: "/admin/studios", label: "Studios", icon: MapPin, testid: "admin-nav-studios" },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart, testid: "admin-nav-orders" },
  { to: "/admin/enquiries", label: "Enquiries", icon: Mail, testid: "admin-nav-enquiries" },
  { to: "/admin/account", label: "Account", icon: KeyRound, testid: "admin-nav-account" },
];

export default function AdminLayout() {
  const { logout, admin } = useAuth();
  return (
    <div className="min-h-screen flex bg-[#F4F4F5]" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-[240px] bg-[#0A0A0A] text-white flex flex-col fixed h-screen">
        <div className="p-6 border-b border-[#27272A] flex items-baseline gap-2">
          <img src={logoWhite} alt="PING" className="h-7 w-auto" />
          <span className="text-[9px] tracking-[0.3em] uppercase text-white/40">Admin</span>
        </div>
        <nav className="flex-1 p-3">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 label-caps btn-transition ${isActive ? "bg-[#E31837] text-white" : "text-white/70 hover:bg-white/5 hover:text-white"}`
              }
              data-testid={n.testid}
            >
              <n.icon className="h-4 w-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-[#27272A] space-y-1">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-4 py-3 label-caps text-white/70 hover:text-white btn-transition">
            <ExternalLink className="h-4 w-4" /> View Site
          </Link>
          <button onClick={logout} className="w-full flex items-center gap-3 px-4 py-3 label-caps text-white/70 hover:text-[#E31837] btn-transition" data-testid="admin-logout-btn">
            <LogOut className="h-4 w-4" /> Logout
          </button>
        </div>
      </aside>

      {/* Content */}
      <div className="flex-1 ml-[240px]">
        <header className="bg-white border-b border-border h-16 flex items-center justify-between px-8 sticky top-0 z-30">
          <p className="label-caps text-muted-foreground">PING India · Distributor Console</p>
          <p className="text-sm text-muted-foreground">{admin?.email}</p>
        </header>
        <div className="p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
